// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d67d9361","240":"f8acbe6d","474":"fa81673c","565":"b9bb0110","643":"19df259e","838":"ea0dbe42"}[chunkId] + ".chunk.js";
};